import React, { useState } from "react"
import Layout from "../../components/layout"
import { navigate } from "gatsby-link"
import { graphql, Link } from "gatsby"
import SEO from "../../components/seo"
import * as styles from "./index.module.less"
import nl2br from "../../utils/nl2br"
import OnDemandSelector from "./_OnDemandSelector"
import { CovidMessage } from "../../components/SpaceProfile/InlineBookTour"

export default ({ data }) => {
  const pageData = data.cms.pageData

  const [modal, setModal] = useState(false)

  const showOnDemandModal = () => {
    if (process.env.GATSBY_TEMPORARY_NOT_AVAILABLE) {
      navigate(`/${process.env.GATSBY_TEMPORARY_NOT_AVAILABLE}`)
    } else {
      setModal(true)
    }
  }

  return (
    <Layout>
      <SEO
        title={pageData.metaTitle}
        description={pageData.metaDescription}
        image={pageData.metaImage[0] ? pageData.metaImage[0].url : ""}
        jsonSchema={pageData.jsonSchema}
      />
      <div className="container">
        <h1>{nl2br(pageData.pageTitle)}</h1>

        <div
          className={"sub-heading"}
          dangerouslySetInnerHTML={{
            __html: pageData.textOnlyRichText,
          }}
        />
      </div>

      <div className="container mb-3">
        <CovidMessage />
      </div>

      <div className="container">
        <div className={`row justify-content-center ${styles.custom_row}`}>
          {pageData.contentBlocks.map((item, idx) => {
            return (
              <div
                key={idx}
                className={`col-md-6 ${
                  pageData.contentBlocks.length > 2 ? "col-lg-4" : ""
                } d-flex`}
              >
                <div className={styles.content_box}>
                  <div>
                    <img src={item.blockImage[0].url} alt={item.blockTitle} />

                    <h2>{item.blockTitle}</h2>
                  </div>
                  <p>{item.blockDescription}</p>
                  <div className={`${styles.meeting_room_content}`}>
                    {item.displayOnDemand ? (
                      <>
                        <Link
                          to={"/on-demand-offices"}
                          className={"btn btn-primary"}
                        >
                          Explore On-demand Offices
                        </Link>
                        {/*<button*/}
                        {/*  onClick={showOnDemandModal}*/}
                        {/*  className={"btn btn-primary"}*/}
                        {/*>*/}
                        {/*  {item.blockLinkLabel}*/}
                        {/*</button>*/}
                      </>
                    ) : (
                      <>
                        {!item.inSiteLink && item.externalLink && (
                          <a
                            href={item.externalLink}
                            target={"_blank"}
                            rel="noreferrer"
                            className={"btn btn-primary"}
                          >
                            {item.blockLinkLabel}
                          </a>
                        )}
                        {item.inSiteLink && (
                          <Link
                            to={item.inSiteLink}
                            className={"btn btn-primary"}
                          >
                            {item.blockLinkLabel}
                          </Link>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {modal && <OnDemandSelector close={() => setModal(false)} />}
    </Layout>
  )
}

export const query = graphql`
  query {
    cms {
      pageData: entry(section: "reserveWorkspacePage") {
        id
        ... on Cms_reserveWorkspacePage_reserveWorkspacePage_Entry {
          id
          pageTitle
          textOnlyRichText
          metaDescription
          jsonSchema
          contentBlocks {
            ... on Cms_contentBlocks_block_BlockType {
              id
              blockTitle
              blockDescription
              blockLinkLabel
              displayOnDemand
              externalLink
              inSiteLink
              blockImage {
                url(width: 600)
              }
            }
          }
          metaTitle
          metaImage {
            url(width: 1200, height: 630)
          }
        }
      }
    }
  }
`
